export default __webpack_public_path__ + "static/media/Qdy.fdd2f3f9.jpeg";